<template>
  <div @mouseenter="isHoveringFocus = true" @mouseleave="isHoveringFocus = false" class="d-inline-block">
    <b-dropdown
      @show="onDropdownShow"
      @hide="onDropdownHide"
      id="dropdown-focus"
      text="Focus"
      variant="outline-dark"
      class="mt-4 mr-3"
    >
      <template #button-content>
        <img
          :src="
            isHoveringFocus || isDropdownOpen ? require('@/assets/icons/focus-active.svg') : require('@/assets/icons/focus.svg')
          "
          width="15"
          height="15"
          class="mr-2"
        />
        <small>SmartSearch</small>
      </template>

      <b-dropdown-text href="#">
        <div class="mt-1 cursor-pointer">
          <b-form-checkbox
            class="custom-checkbox cursor-pointer d-inline-block"
            switch
            size="lg"
            :value="true"
            :unchecked-value="false"
            v-model="localIsSmartSearch"
          />
          <strong @click="localIsSmartSearch = !localIsSmartSearch">
            SmartSearch
            <img src="@/assets/icons/smart-search.svg" class="ml-1" />
          </strong>

          <p @click="localIsSmartSearch = !localIsSmartSearch">
            <small>
              When SmartSearch is on, LegalAtlas will look into its entire corpus of documents to find the most appropriate
              answer.
              <br />
              When SmartSearch is off, you can specify to LegalAtlas where it should search.
            </small>
          </p>
        </div>

        <b-row v-if="!localIsSmartSearch" class="border-top pt-3">
          <b-col v-for="o in FOCUS_OPTIONS" :key="o.value" cols="12" md="12">
            <focus-item :id="o.id" :name="o.name" :description="o.description" @handle-resources="handleResources" />
          </b-col>
        </b-row>
      </b-dropdown-text>
    </b-dropdown>
  </div>
</template>

<script>
import { BRow, BCol, BDropdown, BDropdownText, BFormCheckbox } from "bootstrap-vue";

import { FOCUS_OPTIONS } from "@/constants/settings";

import FocusItem from "./FocusItem";

export default {
  name: "Focus",
  components: { BRow, BCol, BDropdown, BDropdownText, BFormCheckbox, FocusItem },
  props: {
    resources: {
      type: Array,
      default: () => [],
    },
    isSmartSearch: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    localResources: {
      get() {
        return this.resources;
      },
      set(newValue) {
        this.$emit("update:resources", newValue);
      },
    },
    localIsSmartSearch: {
      get() {
        return this.isSmartSearch;
      },
      set(newValue) {
        this.$emit("update:is-smart-search", newValue);
      },
    },
  },
  data: () => ({
    isHoveringFocus: false,
    isDropdownOpen: false,

    FOCUS_OPTIONS,
  }),
  methods: {
    handleResources({ id, value }) {
      if (value) {
        this.localResources.push(id);
      } else {
        const index = this.localResources.findIndex((r) => r === id);
        this.localResources.splice(index, 1);
      }
    },

    onDropdownShow() {
      this.isDropdownOpen = true;
    },
    onDropdownHide() {
      this.isDropdownOpen = false;
    },
  },
};
</script>

<style lang="scss">
#dropdown-focus {
  .dropdown-menu {
    width: 550px !important;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }

  .b-dropdown-text {
    white-space: normal;
    max-height: 400px;
    overflow-y: scroll;
  }
}
</style>
